import React from 'react';
import {
  Briefcase,
  Users,
  ShieldCheck,
  Handshake,
  Building2,
  Target,
  Award,
} from 'lucide-react';
import AboutImg from '../Assets/images/about-page-main-image-first-brick.jpg';
import userf from "../Assets/userf.avif"

const AboutUs = () => {
  return (
    <section className="about-page-fb">
      {/* Header */}
      <div className="about-page-fb-header">
        <h1>About V9 Homes</h1>
        <p>
          Your trusted partner for premier advisory services and high-yield investment opportunities.
        </p>
      </div>

      {/* Hero Image */}
      <div className="about-page-fb-hero-image">
        <img src={AboutImg} alt="V9 Homes Property" />
      </div>

      {/* Main Content Sections */}
      <div className="about-page-fb-main">
        <div className="about-page-fb-content">
          {/* Company Overview */}
          <div className="about-page-fb-section black-section">
            <h2>
              <Building2 size={22} /> Our Intent
            </h2>
            <p>
              At V9 Homes Private Limited, our intent is singular: to provide premier advisory services and high-yield investment opportunities to every individual buyer and investor. We are committed to building a culture of total transparency, ensuring that every transaction is handled with absolute clarity and seamless execution.
            </p>
            <p>
              We are dedicated to creating a "Smooth Ecosystem" that removes traditional friction points and aggressively solves the challenges that typically plague the investment journey. Our goal is to make real estate investment accessible, profitable, and stress-free for all our clients.
            </p>
          </div>

          {/* Leadership / Founders */}
          {/*<div className="about-page-fb-section black-section">
            <h2>
              <Award size={22} /> Leadership (Founders)
            </h2>
            <p>
              The driving force behind V9 Homes is the collaborative expertise of our three founders:
            </p>
            <div className="team-section">
              <div className="team-card">
                <div className="team-image-wrapper">
                  <img
                    src={userf}
                    alt="Founder - V9 Homes"
                    className="team-image"
                  />
                </div>
                <div className="team-content">
                  <h3 className="team-name">Mr. Anshuman L. Nishad</h3>
                  <span className="team-designation">Founder</span>
                </div>
              </div>
              <div className="team-card">
                <div className="team-image-wrapper">
                  <img
                    src={userf}
                    alt="Founder - V9 Homes"
                    className="team-image"
                  />
                </div>
                <div className="team-content">
                  <h3 className="team-name">Mr. Ankit D. Singh</h3>
                  <span className="team-designation">Founder</span>
                </div>
              </div>
              <div className="team-card">
                <div className="team-image-wrapper">
                  <img
                    src={userf}
                    alt="Founder - V9 Homes"
                    className="team-image"
                  />
                </div>
                <div className="team-content">
                  <h3 className="team-name">Mr. Monu J. Gupta</h3>
                  <span className="team-designation">Founder</span>
                </div>
              </div>
            </div>
            <p style={{ marginTop: '20px' }}>
              With a combined experience of over 20 years in the real estate sector, our leadership has witnessed firsthand the hurdles and complexities that investors face—both during and after a purchase. This deep industry insight fueled our mission to transform the real estate experience.
            </p>
          </div>*/}

          {/* Our Team */}
          <div className="about-page-fb-section black-section">
            <h2>
              <Users size={22} /> Our Team
            </h2>
            <p>
              We believe that an organization is only as strong as its team. To us, a team is not just a workforce; it is a family.
            </p>
            <p>
              Recognizing that creating a lasting impact is impossible without the right people, V9 Homes follows a rigorous selection process. We seek out the best in the field—individuals who are not only experts in their roles but also demonstrate an unwavering dedication to their craft.
            </p>
            <p>
              This commitment to excellence ensures that our clients always receive service that is as professional as it is personal. Every team member is aligned with our vision of delivering exceptional results and building long-lasting relationships.
            </p>
          </div>

          {/* Mission */}
          <div className="about-page-fb-section gold-section">
            <h2>
              <Handshake size={22} /> Our Mission
            </h2>
            <p>
              To redefine real estate experiences by delivering world-class advisory services, high-yield investment opportunities, and client-focused results across every transaction.
            </p>
            <p>
              Our mission is rooted in transparency, integrity, and excellence—so you can make confident decisions in the ever-evolving property market.
            </p>
          </div>

          {/* Core Values */}
          <div className="about-page-fb-section black-section">
            <h2>
              <ShieldCheck size={22} /> Core Values
            </h2>
            <ul>
              <li>
                <ShieldCheck size={18} /> Transparency – Absolute clarity in every transaction.
              </li>
              <li>
                <Briefcase size={18} /> Expertise – Market mastery with innovative thinking.
              </li>
              <li>
                <Users size={18} /> Client-First – Your vision drives our every move.
              </li>
              <li>
                <Target size={18} /> Seamless Execution – Removing friction points for smooth experiences.
              </li>
            </ul>
            <p>
              These values are the foundation of every partnership, property, and promise we deliver.
            </p>
          </div>
        </div>
      </div>

      {/* Founder Quote */}
      <div className="about-page-fb-founder-quote">
        <blockquote>
          <p>
            "At V9 Homes, we don't just facilitate investments—we build lasting relationships rooted in trust, transparency, and exceptional results."
          </p>
          <footer>
            <cite>- V9 Homes Team</cite>
          </footer>
        </blockquote>
      </div>
    </section>
  );
};

export default AboutUs;

